import { Button, Heading, Section, Text } from '@react-email/components';

import EmailLayout from './EmailLayout/EmailLayout';
import Message from './common/Message';
import Regards from './common/Regards';

//Staff member or provider
const NewMember = ({
    memberName,
    businessName,
    lastName,
    email,
    businessId,
    isProvider = false,
}) => {

    return (
        <EmailLayout>
            <Section>
                <Message style={{ color: '#555', textAlign: 'left' }}>Dear {memberName},</Message>
                <Heading style={{ textAlign: 'left' }}>We’re pleased to inform you that {businessName} has added you as part of their team on the BeSeen healthcare marketplace.</Heading>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: 'normal',
                    }}
                >
                    To activate your account, there’s just one final step.
                </Text>
                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                    }}
                >
                    Please create a password by clicking the link below to complete your registration:
                </Text>
            </Section>

            {/* Confirm Button */}
            <Section style={{ textAlign: 'center', marginTop: '20px' }}>
                <Button
                    href={`${window.location.origin}/signup?firstName=${encodeURIComponent(memberName)}&lastName=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}&businessName=${encodeURIComponent(businessName)}&businessId=${encodeURIComponent(businessId)}&provider=${encodeURIComponent(isProvider)}`}
                    // href="https://your-confirmation-link.com"
                    style={{
                        padding: '10px 30px',
                        backgroundColor: '#FF5F39',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '28px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                    }}
                >
                    Create Password to Finish Setup
                </Button>
            </Section>


            <Section>

                <Text
                    style={{
                        textAlign: 'start',
                        color: '#555',
                        fontSize: '16px',
                        fontStyle: 'normal',
                        fontWeight: 400,
                        lineHeight: 'normal',
                    }}>

                    Once complete, your profile will be live, and patients will be able to book appointments with you through BeSeen. Should you need assistance at any point, don’t hesitate to reach out to us.
                </Text>

            </Section>
            <Section>
                <Regards />
            </Section>
        </EmailLayout>
    );
};

export default NewMember;
